import React from 'react';
import { Link } from 'react-router-dom';
import { LuZap } from 'react-icons/lu';
import { useCreditsContext } from '../context/CreditsContext';
import { useAuth0 } from '@auth0/auth0-react';

export const TopNav: React.FC = () => {
  const { credits, hasUnlimitedCredits } = useCreditsContext();
  const { user, isAuthenticated } = useAuth0();

  const displayCredits = hasUnlimitedCredits ? '∞' : credits;

  return (
    <header className="h-12 flex-shrink-0 flex items-center px-5 bg-[#060610] border-b border-[#131325] z-30">
      {/* Logo */}
      <div className="flex items-center gap-2 w-72 flex-shrink-0">
        <div className="w-7 h-7 bg-indigo-600 rounded-lg flex items-center justify-center">
          <LuZap className="w-4 h-4 text-white" />
        </div>
        <span className="text-white font-bold text-sm tracking-tight">blitzname</span>
      </div>

      {/* Center nav */}
      <nav className="flex-1 flex items-center justify-center gap-8">
        {[
          { label: 'History', to: '/saved' },
          { label: 'Saved', to: '/favorites' },
          { label: 'Docs', to: '/docs' },
        ].map(({ label, to }) => (
          <Link
            key={label}
            to={to}
            className="text-sm text-gray-400 hover:text-white transition-colors"
          >
            {label}
          </Link>
        ))}
      </nav>

      {/* Right: credits + avatar */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1.5 bg-indigo-900/60 border border-indigo-700/50 rounded-full px-3 py-1">
          <LuZap className="w-3 h-3 text-indigo-400" />
          <span className="text-xs font-semibold text-indigo-300">{displayCredits} credits</span>
        </div>

        {isAuthenticated && user ? (
          <div
            className="w-7 h-7 rounded-full bg-indigo-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0"
            title={user.name}
          >
            {(user.name ?? user.email ?? 'U')[0].toUpperCase()}
          </div>
        ) : (
          <div className="w-7 h-7 rounded-full bg-gray-700 flex-shrink-0" />
        )}
      </div>
    </header>
  );
};
